import advancedVoiceFeatures from './Advanced';
import globalAdvancedVoiceFeatures from './Advanced/Global';
import vietnameseAdvancedVoiceFeatures from './Advanced/Vietnamese';
import basicVoiceFeatures from './Basic';
import globalBasicVoiceFeatures from './Basic/Global';
import vietnameseBasicVoiceFeatures from './Basic/Vietnamese';
import communityVoiceLibraryFeatures from './CommunityVoiceLibrary';
import premiumVoiceFeatures from './Premium';
import globalPremiumVoiceFeatures from './Premium/Global';
import vietnamesePremiumVoiceFeatures from './Premium/Vietnamese';

const voiceFeatures = ({ packages, canUseVouchers, totalVoucher }) => ({
  basicVoice: {
    key: 'basic-voice',
    label: 'basicVoices',
    values: basicVoiceFeatures({ packages, canUseVouchers, totalVoucher }),
    tooltipContent: 'tooltipBasicVoice',
  },
  vietnameseBasicVoice: {
    key: 'vietnamese-basic-voice',
    label: 'vietnameseBasicVoice',
    values: vietnameseBasicVoiceFeatures({ packages }),
    child: true,
  },
  globalBasicVoice: {
    key: 'global-basic-voice',
    label: 'globalBasicVoice',
    values: globalBasicVoiceFeatures({ packages }),
    child: true,
  },
  advancedVoice: {
    key: 'advanced-voice',
    label: 'advancedVoice',
    values: advancedVoiceFeatures({ packages, canUseVouchers, totalVoucher }),
    tooltipContent: 'noteTooltipAdvancedVoice',
  },
  vietnameseAdvancedVoice: {
    key: 'vietnamese-advanced-voice',
    label: 'vietnameseBasicVoice',
    values: vietnameseAdvancedVoiceFeatures({ packages }),
    child: true,
  },
  globalAdvancedVoice: {
    key: 'global-advanced-voice',
    label: 'globalBasicVoice',
    values: globalAdvancedVoiceFeatures({ packages }),
    child: true,
  },
  premiumVoice: {
    key: 'premium-voice',
    label: 'premiumVoice',
    values: premiumVoiceFeatures({ packages, canUseVouchers, totalVoucher }),
    tooltipContent: 'noteTooltipPremiumVoice',
  },
  vietnamesePremiumVoice: {
    key: 'vietnamese-premium-voice',
    label: 'vietnameseBasicVoice',
    values: vietnamesePremiumVoiceFeatures({ packages }),
    child: true,
  },
  globalPremiumVoice: {
    key: 'global-premium-voice',
    label: 'globalBasicVoice',
    values: globalPremiumVoiceFeatures({ packages }),
    child: true,
  },
  communityVoiceLibrary: {
    key: 'community-voice-library',
    label: 'communityVoiceLibrary',
    values: communityVoiceLibraryFeatures({ packages }),
  },
});

export default voiceFeatures;
